import { BaseSettings } from 'Shared/frontend/themes/BaseSettings';
import { OpenSans } from 'Shared/frontend/fonts/OpenSans';
import { Questrial } from '../fonts/Questrial';
import { Oswald } from 'Shared/frontend/fonts/Oswald';
import { INav } from 'Common/config/INav';
import { lazy } from 'solid-js';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';

import {PeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 


export class Showcase2Settings extends BaseSettings
{

	fontIncludes()
	{
		return [
			OpenSans,
			Questrial,
			Oswald 
//			Alatsi,
		];
	}

	fonts()
	{
		return {
			text: '"Questrial", sans-serif',
			heading: '"Oswald", sans-serif',
			subNav: '"Questrial", sans-serif',
			buttons: '"Questrial", sans-serif',
			desktopNav: '"Oswald", sans-serif',
			mobileNav: '"Oswald", sans-serif',
		};
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menu',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon: Home},
					{label:'Menu',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon: Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon: Contact},
					{label:'Contact',	link:'frontend/Contact',	icon: Contact},
				]
			}
		};
	}

	routes()
	{
		return class extends super.routes() {
			frontendContent()
			{
				return [
					...super.frontendContent(),
					
				];
			}
		};
	}
}

